import { c as _c } from "react/compiler-runtime";
import { type MouseEvent, type ReactElement, type Ref } from 'react';
import { ChevronDownIcon } from '../icons/ChevronDownIcon';
import { ChevronUpIcon } from '../icons/ChevronUpIcon';
import { StyledButtonSelectOpener } from './styles';
import Grid from '../Grid';
import Typography from '../Typography';
import Notification from '../Notification';
import type { MultiSelectDropdownItem } from './types';
interface MultiSelectButtonOpenerProps {
  buttonTitle?: string;
  buttonWidth?: string;
  options: MultiSelectDropdownItem[];
  value: Array<string | MultiSelectDropdownItem>;
  isDropdownOpen: boolean;
  disabled: boolean;
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
  ref?: Ref<HTMLButtonElement>;
}
const MultiSelectButtonOpener = t0 => {
  const $ = _c(28);
  const {
    buttonTitle,
    buttonWidth,
    options,
    value,
    isDropdownOpen,
    disabled,
    onClick,
    ref
  } = t0;
  let t1;
  if ($[0] !== options || $[1] !== value) {
    let t2;
    if ($[3] !== value) {
      t2 = option => value.some(selectedValue => {
        if (typeof selectedValue === "string") {
          return selectedValue === option.value;
        }
        return selectedValue.value === option.value;
      });
      $[3] = value;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = options.filter(t2);
    $[0] = options;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const selectedOptionsCount = t1.length;
  const hasSelectedOptions = selectedOptionsCount > 0;
  let t2;
  if ($[5] !== isDropdownOpen) {
    t2 = isDropdownOpen ? <ChevronUpIcon /> : <ChevronDownIcon />;
    $[5] = isDropdownOpen;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = buttonWidth ?? "fit-content";
  let t4;
  if ($[7] !== buttonTitle) {
    t4 = <Typography variant="body2">{buttonTitle}</Typography>;
    $[7] = buttonTitle;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== hasSelectedOptions || $[10] !== options || $[11] !== selectedOptionsCount || $[12] !== value) {
    t5 = hasSelectedOptions && <Notification variant="grey" value={areAllOptionsSelected(value, options) ? "all" : selectedOptionsCount.toString()} />;
    $[9] = hasSelectedOptions;
    $[10] = options;
    $[11] = selectedOptionsCount;
    $[12] = value;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t5) {
    t6 = <Grid width="29.28px">{t5}</Grid>;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t4 || $[17] !== t6) {
    t7 = <Grid display="flex" alignItems="center" gap="8px">{t4}{t6}</Grid>;
    $[16] = t4;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== disabled || $[20] !== hasSelectedOptions || $[21] !== isDropdownOpen || $[22] !== onClick || $[23] !== ref || $[24] !== t2 || $[25] !== t3 || $[26] !== t7) {
    t8 = <StyledButtonSelectOpener ref={ref} variant="outlined" onClick={onClick} rightIcon={t2} disabled={disabled} width={t3} hasOptionsSelected={hasSelectedOptions} isDropdownOpen={isDropdownOpen}>{t7}</StyledButtonSelectOpener>;
    $[19] = disabled;
    $[20] = hasSelectedOptions;
    $[21] = isDropdownOpen;
    $[22] = onClick;
    $[23] = ref;
    $[24] = t2;
    $[25] = t3;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  return t8;
};
const areAllOptionsSelected = (value: Array<string | MultiSelectDropdownItem>, options: MultiSelectDropdownItem[]): boolean => {
  const optionValuesSet = new Set(options.map(option => option.value));
  for (const element of value) {
    const valueAtIndex = element;
    const currentValue = typeof valueAtIndex === 'string' ? valueAtIndex : valueAtIndex.value;
    if (optionValuesSet.has(currentValue)) {
      continue;
    }
    return false;
  }
  return value.length === options.length;
};
export default MultiSelectButtonOpener;